import ResultItem from './result-item';
import React from 'react';

import apiFetch from '@wordpress/api-fetch';
import {Typography, Grid} from '@lapilli-ui/components';
import {YWCAS_LANG, YWCAS_SITE_URL} from '../../../config';

const ProductResults = (props) => {
  const {searchQuery,layout, results, categoryList, noResults, showViewAll, showViewAllText, maxResultsToShow} = props;

  const handleClick = (e, item, redirect = true) => {
    e.stopPropagation();
    redirect && goToItemUrl(item);
    const path = '/ywcas/v1/register?itemID=' + item.post_id + '&queryString=' + searchQuery + '&totalResults=' + results.totalResults+ '&lang='+YWCAS_LANG;
    apiFetch({path}).then(
        null,
        (error) => {
          console.log(error);
        },
    );
  };

  const goToItemUrl = item => {
    if (item.url) {
      window.location.href = item.url;
    }
  };

  const handleSubmit = () =>{
    const showQuery = results.fuzzyToken !== false ?  results.fuzzyToken : searchQuery;
    const path = YWCAS_SITE_URL + '?ywcas=1&post_type=product&lang='+YWCAS_LANG+'&s='+showQuery;
    window.location.href = path;
  }

  const viewAllLabel = showViewAllText.replace('{total}', results.totalResults );
  const items = results.results;

  return (
      <>
        {items && items.length &&
            <Grid className={`ywcas-search-results-grid ${layout}`} columns={1}>
              {items.map((item, index) => <ResultItem key={index} item={item} onClick={handleClick} results={results} categoryResults={categoryList} {...props} />)}
            </Grid>
        }
        {!items && <Typography>{noResults}</Typography>}
        { items && showViewAll && maxResultsToShow < results.totalResults && <div className="ywcas-total-results"> > <a  className="total-results-link" href="#" onClick={handleSubmit}>{viewAllLabel}</a></div>}
      </>
  );
};

export default ProductResults;